import { ILocaleSiteLinks } from '@Hotels-at-Home/hah-fe-core/dist/types/header';
import { IImage } from '@Hotels-at-Home/hah-fe-core/dist/types/image';
import { catalogId } from './siteConfig';

export const siteLinks: ILocaleSiteLinks = {
  en: [
    {
      id: 1,
      url: `https://europe.luxurycollectionstore.com/en?___store=luxeu_en&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=LUXEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Luxury Collection Store',
    },
    {
      id: 2,
      url: `https://europe.whotelsthestore.com/en?___store=wheu_en&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=WHEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'W Hotels The Store',
    },
    {
      id: 3,
      url: `https://europe.shopedition.com/en?___store=edteu_en&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=EDTEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop EDITION',
    },
    {
      id: 4,
      url: `https://europe.westinstore.com/en?___store=hbeu_en&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=HBEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Westin Store',
    },
  ],
  fr: [
    {
      id: 1,
      url: `https://europe.luxurycollectionstore.com/fr?___store=luxeu_fr&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=LUXEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Luxury Collection Store',
    },
    {
      id: 2,
      url: `https://europe.whotelsthestore.com/fr?___store=wheu_fr&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=WHEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'W Hotels The Store',
    },
    {
      id: 3,
      url: `https://europe.shopedition.com/fr?___store=edteu_fr&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=EDTEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop EDITION',
    },
    {
      id: 4,
      url: `https://europe.westinstore.com/fr?___store=hbeu_fr&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=HBEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Westin Store',
    },
  ],
  de: [
    {
      id: 1,
      url: `https://europe.luxurycollectionstore.com/de?___store=luxeu_de&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=LUXEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Luxury Collection Store',
    },
    {
      id: 2,
      url: `https://europe.whotelsthestore.com/de?___store=wheu_de&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=WHEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'W Hotels The Store',
    },
    {
      id: 3,
      url: `https://europe.shopedition.com/de?___store=edteu_de&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=EDTEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop EDITION',
    },
    {
      id: 4,
      url: `https://europe.westinstore.com/de?___store=hbeu_de&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=HBEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Westin Store',
    },
  ],
  es: [
    {
      id: 1,
      url: `https://europe.luxurycollectionstore.com/es?___store=luxeu_es&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=LUXEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Luxury Collection Store',
    },
    {
      id: 2,
      url: `https://europe.whotelsthestore.com/es?___store=wheu_es&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=WHEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'W Hotels The Store',
    },
    {
      id: 3,
      url: `https://europe.shopedition.com/es?___store=edteu_es&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=EDTEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop EDITION',
    },
    {
      id: 4,
      url: `https://europe.westinstore.com/es?___store=hbeu_es&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=HBEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Westin Store',
    },
  ],
};

export const bonvoyLogo: IImage = {
  src: '/images/misc/bonvoy-logo.svg',
  alt: 'Shop logo',
  height: '47.25',
  width: '100',
};
